import React, { Component } from 'react';
import PropTypes from 'prop-types';
import makeRequest from 'utils/makeRequest';
import ElectionWidget from 'routes/home/components/common/ElectionWidget/ElectionWidget';
import RHSWidgetWithExitPoll from 'components_v2/common/ExitPollRHSWrapper/ExitPollRHSWrapper';
import { getSiteDomain } from '../../utils/common';

const HP_ELECTION_FEED_URL = `${getSiteDomain()}/homepage_election_feed_iframe.cms?feedtype=sjson`;

const HP_ELECTION_EXIT_POLL = `${getSiteDomain()}/homepage_exitpll_feed.cms?feedtype=sjson`;

const rhsElectionExitpollConfig = {
  dataUrl: `${getSiteDomain()}/feed_news_list/msid-82161259,tag-electioniframerhswidget,feedtype-sjson.cms`,
  id: 'exitpoll',
  name: 'exitpoll',
  tn: 'electionexitpoll',
};

function fetchData(feedUrl, callback) {
  makeRequest
    .get(feedUrl, {}, 'skipfeedengine')
    .catch(err => console.log(err))
    .then(data => {
      if (
        data &&
        data.status === 200 &&
        data.data &&
        typeof callback === 'function'
      ) {
        callback(data.data);
      }
    });
}

/**
 * Component to show election widgets in iframe
 */
class RenderElectionWidgetIframe extends Component {
  constructor(props) {
    super(props);
    this.state = {
      electionHPData: null,
    };
  }

  componentDidMount() {
    const { isExitPoll } = this.props;
    if (isExitPoll) {
      fetchData(HP_ELECTION_EXIT_POLL, this.setElectionHPData);
    } else {
      fetchData(HP_ELECTION_FEED_URL, this.setElectionHPData);
    }
    this.fireComscore();
  }

  fireComscore = () => {
    if (window.TimesApps && window.TimesApps.fireComscore) {
      window.TimesApps.fireComscore();
    }
  };

  setElectionHPData = data => {
    this.setState({ electionHPData: data });
  };

  render() {
    const {
      isWapView,
      isExitPoll,
      hideSharing,
      hideHeading,
      hideLink,
      hideLiveblog,
      hideStarCandidate,
      hideInfocus,
      exitPollRhsWidget,
      hideETheading,
      bgColor,
      bgColorOuter,
      wgtclient,
      hideExitHeading,
      showDots,
      ettxt,
    } = this.props;
    const { electionHPData } = this.state;

    if (!electionHPData) {
      return null;
    }

    if (exitPollRhsWidget === true) {
      return (
        <React.Fragment>
          <RHSWidgetWithExitPoll
            key={rhsElectionExitpollConfig.tn}
            hideLiveblog={hideLiveblog}
            item={rhsElectionExitpollConfig}
            isIframeExitPoll={isExitPoll}
            isIframeCssRequired
            hideStarCandidate={hideStarCandidate}
            preActiveState={this.props.preActiveState}
            bgColor={bgColor}
            bgColorOuter={bgColorOuter}
            ettxt={ettxt}
          />
        </React.Fragment>
      );
    }

    return (
      <React.Fragment>
        <ElectionWidget
          isWapView={isWapView}
          sectionData={electionHPData}
          key="election"
          isExitPoll={isExitPoll}
          hideSharing={hideSharing}
          hideHeading={hideHeading}
          hideLink={hideLink}
          hideLiveblog={hideLiveblog}
          hideStarCandidate={hideStarCandidate}
          isIframeCssRequired
          hideInfocus={hideInfocus}
          hideETheading={hideETheading}
          bgColor={bgColor}
          bgColorOuter={bgColorOuter}
          wgtclient={wgtclient}
          hideExitHeading={hideExitHeading}
          showDots={showDots}
          ettxt={ettxt}
        />
      </React.Fragment>
    );
  }
}

RenderElectionWidgetIframe.defaultProps = {
  isExitPoll: false,
  isWapView: false,
  hideSharing: false,
  hideLink: false,
  hideHeading: false,
  hideLiveblog: false,
  hideStarCandidate: false,
  hideETheading: false,
  hideExitHeading: false,
  preActiveState: null,
  bgColor: '',
  bgColorOuter: '',
  wgtclient: '',
  ettxt: '',
};

RenderElectionWidgetIframe.propTypes = {
  isExitPoll: PropTypes.bool,
  isWapView: PropTypes.bool,
  hideSharing: PropTypes.bool,
  hideHeading: PropTypes.bool,
  hideLink: PropTypes.bool,
  hideLiveblog: PropTypes.bool,
  hideStarCandidate: PropTypes.bool,
  hideETheading: PropTypes.bool,
  preActiveState: PropTypes.string,
  bgColor: PropTypes.string,
  bgColorOuter: PropTypes.string,
  wgtclient: PropTypes.string,
  hideExitHeading: PropTypes.bool,
  ettxt: PropTypes.string,
};

export default RenderElectionWidgetIframe;
